module.exports = __webpack_public_path__ + "img/layout_right_1.cf0b1144.png";